// @flow

import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';
import styled, { css, ThemeProvider } from 'styled-components';

import settings from '../config/settings';
import themes from '../config/themes';

import ContainedImage from './ContainedImage';
import MenuIcon from './MenuIcon';

const HeaderWrapper = styled.header`
  background: ${props => props.theme.headerBg};
  color: white;
  left: ${props => props.navRevealed ? `calc(-100% + ${settings.navSize})` : 0};
  min-height: ${settings.headerHeight};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
  ${settings.navTransition && css`transition: ${settings.navTransition};`}
`;

const Brand = styled(ContainedImage).attrs({
  image: props => props.theme.brandImage,
  width: '44px',
  height: '18px'
})`
  left: 15px;
  position: absolute;
  text-transform: uppercase;
  top: 16px;
`;

const Title = styled.h1`
  color: ${props => props.theme.headerColor};
  display: block;
  font-size: 16px;
  line-height: ${settings.headerHeight};
  margin: 0;
  overflow: hidden;
  padding: 0 50px 0 70px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type Props = {
  location: any, // React-Router provided
  navRevealed: boolean,
  title: string,
  toggleNav: () => void
}

class Header extends Component<Props> {

  static defaultProps = {
    navRevealed: false,
    title: 'Baart Tools'
  }

  render() {
    const { navRevealed, title } = this.props;

    // Select a theme/config based on the path
    let tool = 'baart';
    let url = '/';
    const match = matchPath(this.props.location.pathname, { path: '/tools/:tool' });
    if (match && match.params.tool && themes.hasOwnProperty(match.params.tool)) {
      tool = match.params.tool;
      url = `/tools/${tool}`;
    }
    let theme = themes[tool];

    return (
      <ThemeProvider theme={theme}>
        <HeaderWrapper navRevealed={navRevealed}>
          <Brand>
            <Link to={url}>{tool.toUpperCase()}</Link>
          </Brand>
          <Title>{title}</Title>
          <MenuIcon
            navRevealed={navRevealed}
            onClick={this.props.toggleNav}
          />
        </HeaderWrapper>
      </ThemeProvider>
    );
  }

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js